import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  Constraint,
  Event,
  Id,
  Identifiable,
  List,
  Milestone,
  Task,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  constraints: (Identifiable<Constraint> & {
    target:
      | Identifiable<Task>
      | Identifiable<List>
      | Identifiable<Event>
      | Identifiable<Milestone>;
    origin:
      | Identifiable<Task>
      | Identifiable<List>
      | Identifiable<Event>
      | Identifiable<Milestone>;
  })[];
  retrieveElementConstraints(
    request: Boundaries["retrieveElementConstraints"]["request"],
  ): void;
}

function useRetrieveElementConstraints(elementId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveElementConstraintsRequestPending(elementId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveElementConstraintsRequestSuccess(elementId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveElementConstraintsRequestFailure(elementId),
    ),
    constraints: useSelector(() => selector.getElementConstraints(elementId)),
    retrieveElementConstraints: core.retrieveElementConstraints,
  };
}

export { useRetrieveElementConstraints };
